
export enum PageType {
    AUTH0_REDIRECT = 'auth0-redirect',
    AUTHOR = 'author',
    CATEGORY = 'category',
    ERROR = 'error',
    INDEX = 'index',
    ONE_DIGITAL = 'one-digital',
    PAGE = 'page',
    REGISTER = 'register',
    SEARCH = 'search',
    SIGN_IN = 'sign-in',
    STORY = 'story',
    SUBSCRIBE = 'subscribe',
    TAG = 'tag',
    VERIFY_PASSWORDLESS = 'verify-passwordless',
    VERIFY_PASSWORDLESS_ERROR = 'verify-passwordless-error'
}
